<h2>Request successfully submitted!</h2>
<h6>Request ID: {{ requestId }}</h6>
<h6 *ngIf="proNumber">General Claims Pro Number: {{ proNumber }}</h6>
<div>Your request has successfully been submitted. Continue browsing or select the Salvage Request tab to review your request history.</div>
<div class="salvageSuccessDialog__contBtn">
  <button mat-flat-button xpoLargeButton xpoButton color="primary" (click)="closeDialog()">
    Continue
  </button>
</div>
